<template>
  <PatientAttentionLevelPopover @levelChange="handleChange" :option="value" :options="levels" :disabled="!editable">
    <ul class="levels" :data-type="value">
      <li v-for="(active, index) of items" :class="{ active }" :key="index" />
    </ul>
  </PatientAttentionLevelPopover>
</template>

<script>
import PatientAttentionLevelPopover from '@ui-kit/components/attention-level/PatientAttentionLevelPopover.vue';

export default {
  components: {
    PatientAttentionLevelPopover,
  },
  props: {
    value: String,
    patientId: {
      type: Number,
      required: true,
    },
    editable: Boolean,
  },
  data: () => ({
    levels: {
      high: {
        size: 3,
        optLabel: 'COMMON.HIGH',
        optValue: 'high'
      },
      low: {
        size: 2,
        optLabel: 'COMMON.LOW',
        optValue: 'low'
      },
      very_low: {
        size: 1,
        optLabel: 'COMMON.VERY_LOW',
        optValue: 'very_low'
      },
    },
  }),
  computed: {
    items() {
      const items = Array.from({ length: Object.keys(this.levels).length });
      return items.map((_, index) => index <= this.levels[this.value]?.size - 1);
    },
  },
  methods: {
    handleChange(value) {
      this.$emit('input', value);
      this.$emit('change', value);
    }
  },
};
</script>

<style lang="scss" scoped>
.levels {
  display: flex;
  gap: 0.15rem;

  &[data-type="high"] li.active {
    background: $hard-red;
  }

  &[data-type="low"] li.active {
    background: $yellow-wuk;
  }

  &[data-type="very_low"] li.active {
    background: $hard-green;
  }

  li {
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 0.1875rem;
    background: $context-color-7;
  }
}
</style>
